import React, { useEffect } from "react";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import { TOCSectionSelectedtype } from "@frameworks/web/components/features/TOC/Equity/EqConstants";
const ProductButtons = (props) => {
    const [activeButton, setActiveButton] = React.useState();
    useEffect(() => {
        activeButtons();
    }, [props.activeButton]);
    const activeButtons = () => {
        switch (props.type) {
            case TOCSectionSelectedtype.ORDER: {
                setActiveButton((prevState) => {
                    var _a, _b;
                    return {
                        title: (_a = props.activeButton) === null || _a === void 0 ? void 0 : _a.ORDER,
                        value: (_b = props.activeButton) === null || _b === void 0 ? void 0 : _b.ORDER,
                        disabled: prevState === null || prevState === void 0 ? void 0 : prevState.disabled,
                        rank: prevState === null || prevState === void 0 ? void 0 : prevState.rank,
                    };
                });
                break;
            }
            case TOCSectionSelectedtype.PRODUCT: {
                setActiveButton((prevState) => {
                    var _a, _b;
                    return {
                        title: (_a = props.activeButton) === null || _a === void 0 ? void 0 : _a.PRODUCT,
                        value: (_b = props.activeButton) === null || _b === void 0 ? void 0 : _b.PRODUCT,
                        disabled: prevState === null || prevState === void 0 ? void 0 : prevState.disabled,
                        rank: prevState === null || prevState === void 0 ? void 0 : prevState.rank,
                    };
                });
                break;
            }
            case TOCSectionSelectedtype.VALIDITY: {
                setActiveButton((prevState) => {
                    var _a, _b;
                    return {
                        title: (_a = props.activeButton) === null || _a === void 0 ? void 0 : _a.VALIDITY,
                        value: (_b = props.activeButton) === null || _b === void 0 ? void 0 : _b.VALIDITY,
                        disabled: prevState === null || prevState === void 0 ? void 0 : prevState.disabled,
                        rank: prevState === null || prevState === void 0 ? void 0 : prevState.rank,
                    };
                });
                break;
            }
            case TOCSectionSelectedtype.FREQUENCY: {
                setActiveButton((prevState) => {
                    var _a, _b;
                    return {
                        title: (_a = props.activeButton) === null || _a === void 0 ? void 0 : _a.FREQUENCY,
                        value: (_b = props.activeButton) === null || _b === void 0 ? void 0 : _b.FREQUENCY,
                        disabled: prevState === null || prevState === void 0 ? void 0 : prevState.disabled,
                        rank: prevState === null || prevState === void 0 ? void 0 : prevState.rank,
                    };
                });
                break;
            }
            case TOCSectionSelectedtype.INVESTMENT: {
                setActiveButton((prevState) => {
                    var _a, _b;
                    return {
                        title: (_a = props.activeButton) === null || _a === void 0 ? void 0 : _a.INVESTMENT,
                        value: (_b = props.activeButton) === null || _b === void 0 ? void 0 : _b.INVESTMENT,
                        disabled: null,
                        rank: null,
                    };
                });
                break;
            }
            case TOCSectionSelectedtype.SCHEMETYPE: {
                setActiveButton((prevState) => {
                    var _a, _b;
                    return {
                        title: (_a = props.activeButton) === null || _a === void 0 ? void 0 : _a.SCHEMETYPE,
                        value: (_b = props.activeButton) === null || _b === void 0 ? void 0 : _b.SCHEMETYPE,
                        disabled: null,
                        rank: null,
                    };
                });
                break;
            }
            case TOCSectionSelectedtype.RETURNOPTION: {
                setActiveButton((prevState) => {
                    var _a, _b;
                    return {
                        title: (_a = props.activeButton) === null || _a === void 0 ? void 0 : _a.RETURNOPTION,
                        value: (_b = props.activeButton) === null || _b === void 0 ? void 0 : _b.RETURNOPTION,
                        disabled: null,
                        rank: null,
                    };
                });
                break;
            }
            case TOCSectionSelectedtype.DIVFREQUENCY: {
                setActiveButton((prevState) => {
                    var _a, _b;
                    return {
                        title: (_a = props.activeButton) === null || _a === void 0 ? void 0 : _a.DIVFREQUENCY,
                        value: (_b = props.activeButton) === null || _b === void 0 ? void 0 : _b.DIVFREQUENCY,
                        disabled: null,
                        rank: null,
                    };
                });
                break;
            }
            case TOCSectionSelectedtype.ALERTS: {
                setActiveButton((prevState) => {
                    var _a, _b;
                    return {
                        title: (_a = props.activeButton) === null || _a === void 0 ? void 0 : _a.ALERTS,
                        value: (_b = props.activeButton) === null || _b === void 0 ? void 0 : _b.ALERTS,
                        disabled: null,
                        rank: null,
                    };
                });
                break;
            }
            case TOCSectionSelectedtype.MFFIRSTINSTALLMENT: {
                setActiveButton((prevState) => {
                    var _a, _b;
                    return {
                        title: (_a = props.activeButton) === null || _a === void 0 ? void 0 : _a.MFFIRSTINSTALLMENT,
                        value: (_b = props.activeButton) === null || _b === void 0 ? void 0 : _b.MFFIRSTINSTALLMENT,
                        disabled: null,
                        rank: null,
                    };
                });
                break;
            }
            case TOCSectionSelectedtype.REDEEMBY: {
                setActiveButton((prevState) => {
                    var _a, _b;
                    return {
                        title: (_a = props.activeButton) === null || _a === void 0 ? void 0 : _a.REDEEMBY,
                        value: (_b = props.activeButton) === null || _b === void 0 ? void 0 : _b.REDEEMBY,
                        disabled: prevState === null || prevState === void 0 ? void 0 : prevState.disabled,
                        rank: null,
                    };
                });
                break;
            }
            case TOCSectionSelectedtype.REDEEMMODE: {
                setActiveButton((prevState) => {
                    var _a, _b;
                    return {
                        title: (_a = props.activeButton) === null || _a === void 0 ? void 0 : _a.REDEEMMODE,
                        value: (_b = props.activeButton) === null || _b === void 0 ? void 0 : _b.REDEEMMODE,
                        disabled: null,
                        rank: null,
                    };
                });
                break;
            }
        }
    };
    return (React.createElement(React.Fragment, null, props.buttonsList &&
        props.buttonsList.map((button, idx) => {
            var _a, _b, _c, _d;
            return (React.createElement(EdButton, { btnTyp: "midnight-blue-border", value: button.title, returnValue: button.value, className: `product-buttons ${props.parentClassName ? props.parentClassName : ""} ${((_a = activeButton === null || activeButton === void 0 ? void 0 : activeButton.title) === null || _a === void 0 ? void 0 : _a.toLowerCase()) ===
                    ((_b = button === null || button === void 0 ? void 0 : button.title) === null || _b === void 0 ? void 0 : _b.toLowerCase()) ||
                    ((_c = activeButton === null || activeButton === void 0 ? void 0 : activeButton.title) === null || _c === void 0 ? void 0 : _c.toLowerCase()) ===
                        ((_d = button === null || button === void 0 ? void 0 : button.value) === null || _d === void 0 ? void 0 : _d.toLowerCase())
                    ? props.onSelectBackground
                        ? "active bg_aqua_white"
                        : "active"
                    : ""}`, onClick: (e) => {
                    setActiveButton(button);
                    props.onClickAction &&
                        props.onClickAction(e, props === null || props === void 0 ? void 0 : props.type, button.title);
                }, disabled: button.disabled, key: idx }));
        })));
};
export default ProductButtons;
